// extracted by mini-css-extract-plugin
export default {"link":"nSRVhJhj56RpUG6zd615"};